import { useState, useEffect } from "react";
import { Button, Alert } from "@mui/material";
import {
  PaymentElement,
  useStripe,
  useElements,
  useCheckout,
} from "@stripe/react-stripe-js";

const PaymentForm = ({ invoiceId, clientSecret }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {

      return;
    }

    setIsLoading(true);
    let url = `${window.location.origin}/invoices`;
    if (!Array.isArray(invoiceId)) {
      url = `${window.location.origin}/invoices/${invoiceId}`
    }
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: url,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "accordion",
  };

  console.log(`client secret: ${clientSecret}`)
  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <Button variant="contained" disabled={isLoading || !stripe || !elements} id="submit" style={{marginTop: 10}} onClick={handleSubmit}>
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </Button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
};

export default PaymentForm;
